import axios from 'axios';
import fileDownload from 'js-file-download';
import * as endpoint from '../../../endpoint';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForBlob } from '../../axiosConfig';

/**
 * ログCSVダウンロード
 *
 * @param {*} apiToken APIトークン
 * @param {*} options 検索条件
 * @returns APIレスポンス
 */
const exportActivityLogCsv = (apiToken, options) => dispatch => {
  consolelog('[API CALL] exportActivityLogCsv()');
  configureAxiosForBlob(apiToken);

  // APIエンドポイント
  const url = endpoint.API_DOWNLOAD_LOGS_CSV;
  // リクエストパラメータの設定
  const { cancelToken, cancelTokenKey } = createCancelToken(
    'exportActivityLogCsv',
  );
  const params = {
    cancelToken,
    params: options,
  };

  return axios
    .get(url, params)
    .then(res => {
      delCancelToken(cancelTokenKey);
      const filename = res.headers['content-disposition'].split('=')[1];
      fileDownload(res.data, filename);
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    });
};

export default exportActivityLogCsv;
